import { render } from "./AddAccordionModal.vue?vue&type=template&id=ea210282&scoped=true"
import script from "./AddAccordionModal.vue?vue&type=script&lang=js"
export * from "./AddAccordionModal.vue?vue&type=script&lang=js"

import "./AddAccordionModal.vue?vue&type=style&index=0&id=ea210282&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea210282"],['__file',"src/components/accordion/AddAccordionModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ea210282"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ea210282', __exports__)) {
    api.reload('ea210282', __exports__)
  }
  
  module.hot.accept("./AddAccordionModal.vue?vue&type=template&id=ea210282&scoped=true", () => {
    api.rerender('ea210282', render)
  })

}


export default __exports__